import React from 'react';

const Failed = () => {
    return (
        <div className='failed'>
            <h1> Sorry! Your payment is not successes </h1>
        </div>
    );
};

export default Failed;